import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpParamsUtils } from 'ib/internetbank-core/utils/http-params.utils';


import { HttpClientExtension } from '../../common/services/http-client-extension.service';

import { Story } from './models/stories.entities';

@Injectable()
export class StoriesDataService {

	private readonly url: string = 'rest/biz/stories';

	constructor(
		private http: HttpClientExtension,
	) { }

	public getList(): Observable<Array<Story>> {
		return this.http.get<Array<Story>>(`${this.url}/list`);
	}

	public markAsViewed(storyId: number): Observable<void> {
		return this.http.put<void>(`${this.url}/view-story`, undefined, {
			params: HttpParamsUtils.createHttpParams(
				{ id: storyId },
			),
		});
	}

}